import React from 'react';
import './container.css';
import { SvgFile } from '../SvgFile';
import { CustomMenu } from '../customMenu';
import globus from '../../assets/svg/World.svg';
import play from '../../assets/svg/Play.svg';

export const Container = ({ onMapClick, activeToolId, setVideoShowed, setGlobeShowed }) => {
  return (
    <div className='svg_container' onClick={onMapClick}>
      <SvgFile activeToolId={activeToolId} />

      {activeToolId === 'SAMARQAND' && (
        <>
          <svg
            className='arrowsBottom'
            id='Layer_1'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 105.67 116.43'
          >
            <path d='M84.32,80.09c13,3.68,21.35,9.56,21.35,16.19,0,11.13-23.65,20.15-52.83,20.15S0,107.41,0,96.28c0-6.79,8.79-12.79,22.27-16.44l1.48,2c1,1.37,2.13,2.73,3.26,4.06-9.43,2.28-15.47,5.8-15.47,9.75,0,6.88,18.29,12.46,40.86,12.46s40.86-5.58,40.86-12.46c0-3.67-5.24-7-13.56-9.26,1.64-2,3.18-4.14,4.62-6.3Z' />
          </svg>
          <svg
            className='arrowsTop'
            id='Layer_1'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 105.67 116.43'
          >
            <path d='M70.19,82.78A69.18,69.18,0,0,1,55.08,95.29a2.14,2.14,0,0,1-2.43.07,85,85,0,0,1-21-18.76C24,67,19.13,56.34,17.48,46.07s-.11-20.42,5.07-28.56a35,35,0,0,1,7.83-8.68C37.68,3,46-.06,54.34,0A34.89,34.89,0,0,1,83.15,16.68c5.57,9.17,6.77,20.87,4.33,32.72A71.93,71.93,0,0,1,70.19,82.75v0ZM52.76,18.51A17.88,17.88,0,1,1,34.88,36.38,17.87,17.87,0,0,1,52.76,18.51Z' />
          </svg>
        </>
      )}

      <CustomMenu onMapClick={onMapClick} />

      <div className='controlsBox'>
        <img onClick={setGlobeShowed} src={globus} alt='globus' />
        <img onClick={() => setVideoShowed(true)} src={play} alt='play' />
      </div>
    </div>
  );
};
